import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import jsonValue from "./Skill.json";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Icon from "./Icon";
import Slider from "./Slider";
export default function ControlledAccordions(props) {
  const [expanded, setExpanded] = React.useState(false);
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div>
      {jsonValue &&
        jsonValue.map((i, index) => {
          return (
            <Accordion
              expanded={expanded === `${i.value}`}
              onChange={handleChange(i.value)}
              className="md:w-[85%]  lg:w-[70%] mb-4 exc border "
              
              key={index}
            >
              <AccordionSummary
                expandIcon={
                  <ExpandMoreIcon
                  className="muitext"
                    style={{ height: "44px" }}
                  />
                }
                aria-controls="panel1bh-content"
                id="panel1bh-header"
                style={{ width: "100%" }}
              >
                <div className="flex flex-row justify-between">
                  <div className={i.style}>
                    <Icon iconType={i.Icon} />
                  </div>
                  <div className="ml-8">
                    <Typography
                    className="muitext"
                      sx={{ width: "%", flexShrink: 0 }}
                      style={{  fontSize: "24px" }}
                    >
                      {i.tech}
                    </Typography>
                  </div>
                </div>
              </AccordionSummary>
              <AccordionDetails className="dark:text-white">
              <Typography className="text-[#17A6DB] dark:text-[#30dada]">Below is my Expertisation graph   {i.tech}</Typography>
                <div className="mx-4">
                <Slider value={i.value} color={i.bg} mark={i.marks} /> </div>
                <Typography>{i.color}</Typography>
              </AccordionDetails>
            </Accordion>
          );
        })}
    </div>
  );
}
